import { useState } from 'react';

import useSWR, { SWRConfiguration } from 'swr';

// Utils
import { get } from '@/utils/client';
import { injectEndpointUrlParams } from '@/utils/injectEndpointUrlParams';

// API Endpoints
import { GROUP_LABELS } from '@/lib/routes/apiEndpoints';

export type GroupLabel = {
    id: number;
    label: string;
    created_at: string;
    updated_at: string;
};

export type UseGroupLabelsProps = {
    activeGroupID: string | number;
    options?: SWRConfiguration;
    params?: Record<string, any>;
    shouldFetch?: boolean;
};

export const useGroupLabels = ({
    activeGroupID = undefined,
    options = {},
    params = undefined,
    shouldFetch = true
}: UseGroupLabelsProps) => {
    const [requestParams, setRequestParams] = useState(params);

    const apiEndpoint = injectEndpointUrlParams(GROUP_LABELS, {
        GROUP_ID: activeGroupID
    });
    const {
        data: labels,
        mutate: mutateLabels,
        error: errorLabels,
        isLoading
    } = useSWR<GroupLabel[], Error>(
        shouldFetch
            ? [apiEndpoint, requestParams ? JSON.stringify(requestParams) : undefined]
            : null,
        ([url]) => get(url, requestParams).then((res) => res.data?.data),
        {
            shouldRetryOnError: false,
            keepPreviousData: true, // Keep previous data while fetching new search results
            ...options
        }
    );

    return {
        labels,
        mutateLabels,
        errorLabels,
        isLoading,
        isLoadingInitialData: isLoading && !labels,
        requestParams,
        setRequestParams
    };
};
